import React, { FC, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import CollapsibleForm from '../../../CollapsibleForm'
import { SettingsPopupProps } from '../../SettingsPopup'
import { useSettingsPopupState } from '../../hooks'
import { ModalContent, ModalFooter, ModalFooterButton } from '../../styles'
import { useSchemas } from './hooks'
import { stepNlpSettingsSelector } from '../../../../store/botNlp/selectors'
import { actions } from '../../../../store/botNlp/botNlpSlice'
import { getValidationErrors } from './utils'
import { isStepNlpEnabledInStepTypeDefaultsSelector } from '../../../../store/flow/selectors/isStepNlpEnabledSelector'
import { disableStepNlpInStepTypeDefaults } from '../../../../actions/bot'

export const StepNlpConfigsForm: FC<SettingsPopupProps> = props => {
  const dispatch = useDispatch()
  const settings = useSelector(stepNlpSettingsSelector)
  const isStepNlpEnabledInStepTypeDefaults = useSelector(isStepNlpEnabledInStepTypeDefaultsSelector)

  const submitButtonRef = useRef<HTMLButtonElement>(null)

  const { formData, onFormDataChange } = useSettingsPopupState(() => ({
    ...settings,
    enabled: settings?.enabled || isStepNlpEnabledInStepTypeDefaults
  }))

  const { schema, uiSchema } = useSchemas(formData)

  return (
    <>
      <ModalContent>
        <CollapsibleForm
          schema={schema}
          uiSchema={uiSchema}
          formData={formData}
          validationErrorsByField={getValidationErrors(formData) as any}
          className={props.className}
          liveValidate={true}
          onChange={onFormDataChange}
          submitButtonRef={submitButtonRef}
          onSubmit={async ({ formData }) => {
            dispatch(actions.updateStepNlpSettings(formData))

            if (isStepNlpEnabledInStepTypeDefaults) {
              dispatch(disableStepNlpInStepTypeDefaults())
            }
            props.close?.()
          }}
        />
      </ModalContent>

      <ModalFooter>
        <ModalFooterButton
          label="Close"
          className="e2e-close-bot-modal-button"
          onClick={props.close}
        />

        <ModalFooterButton
          emphasis="primary"
          label="Save"
          className="e2e-modal-success-button"
          onClick={() => submitButtonRef.current?.click?.()}
        />
      </ModalFooter>
    </>
  )
}
